import * as React from 'react';

import { useLocation, useParams } from 'js/lib/useRouter';

import ProductDescriptionPageHeader from 'bundles/composable-page-header-consumer/header-renderers/ProductDescriptionPageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import PaidMediaFooter from 'bundles/page-footer/components/PaidMediaFooter';
import CoachChatContainer from 'bundles/unified-description-page-common/components/coach/CoachChatContainer';
import { useSpecializationPageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';
import { useCoachCareerFitAssistantData } from 'bundles/unified-description-page-common/providers/specialization/CoachCareerFitAssistantProvider';
import { getPageHeaderProps } from 'bundles/unified-description-page-common/utils/getProductHeaderProps';
import isGoogleMarketingPage from 'bundles/unified-description-page-common/utils/isGoogleMarketingPage';
import { isPaidMediaXDP } from 'bundles/unified-description-page-common/utils/isPaidMediaXDP';

const ConsumerHeaderFooterWrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const params = useParams();
  const s12nPageData = useSpecializationPageData();
  const headerRef = React.useRef<HTMLSpanElement>(null);
  const { coachCareerFitAssistantEnabled } = useCoachCareerFitAssistantData();
  let productSlug: string | undefined = params.productSlug;

  // Ensure we use the canonical slug if on Google XDP.
  if (isGoogleMarketingPage(location.pathname)) {
    productSlug = s12nPageData?.slug;
  }

  const pageHeaderProps = getPageHeaderProps({ pathname: location.pathname, productSlug });

  const showSimpleHeader = !!isPaidMediaXDP(location.pathname)?.length;

  return (
    <React.Fragment>
      <span ref={headerRef}>
        <ProductDescriptionPageHeader
          getS12nCertificateBannerProps={pageHeaderProps?.getS12nCertificateBannerProps}
          productDiscountPromoBannerProps={
            getPageHeaderProps({ pathname: location.pathname, productSlug })?.productDiscountPromoBannerProps
          }
          showSimpleHeader={showSimpleHeader}
        />
      </span>
      <UniversalPageFeatures />
      <main>{children}</main>
      {coachCareerFitAssistantEnabled && <CoachChatContainer headerRef={headerRef} />}
      {showSimpleHeader ? <PaidMediaFooter isStickyBarPresent /> : <PageFooter isStickyBarPresent />}
    </React.Fragment>
  );
};

export default ConsumerHeaderFooterWrapper;
